<template>
  <v-calendar class="student-calendar" :attributes="ratings"/>
</template>

<script>
  export default {
    name: 'student-calendar',
    props: ['ratings', 'colorMap', 'ratingMap'],
    mixins: [],
    data () {
      return {}
    },
    methods: {},
    computed: {},
    watch: {}
  }
</script>

<style scoped>
  .student-calendar >>> .popover-content {
    border-radius: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/student/engagement/StudentCalendar.vue